import { render, staticRenderFns } from "./SupplementaryExamReport.vue?vue&type=template&id=b61b800a&scoped=true"
import script from "./SupplementaryExamReport.vue?vue&type=script&lang=js"
export * from "./SupplementaryExamReport.vue?vue&type=script&lang=js"
import style0 from "./SupplementaryExamReport.vue?vue&type=style&index=0&id=b61b800a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61b800a",
  null
  
)

export default component.exports